import type { PresetCreateDraft } from '../../types/api.js';
import { emptyPresetParcel } from './parcel.js';

function defaultCreateDraft(): PresetCreateDraft {
  return {
    description: '',
    title: '',
    shortDescription: '',
    price: '',
    oldPrice: '',
    avitoLink: '',
    image: '',
    images: [],
    parcel: emptyPresetParcel(),
    specs: { cpu: '', gpu: '', motherboard: '', ram: '', psu: '', storage: '', caseName: '' }
  };
}

let createDraft: PresetCreateDraft = defaultCreateDraft();

export function getCreateDraft(): PresetCreateDraft {
  return createDraft;
}

export function resetCreateDraft(overrides?: Partial<PresetCreateDraft>): PresetCreateDraft {
  createDraft = defaultCreateDraft();
  if (overrides && typeof overrides === 'object') {
    Object.assign(createDraft, overrides);
    if (overrides.specs) createDraft.specs = Object.assign({}, createDraft.specs, overrides.specs);
    if (overrides.parcel) createDraft.parcel = Object.assign({}, createDraft.parcel, overrides.parcel);
    if (overrides.images) createDraft.images = overrides.images.slice();
  }
  return createDraft;
}
